// MainLayout.jsx

import { Outlet } from "react-router-dom";
import NavBar from "../component/navbar";
import "../assets/css/mainlayout.css";
import { FaHeadset, FaTimes } from "react-icons/fa";
import { useState } from "react";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import configModule from "../../config.js";

const MainLayout = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [faqs, setFaqs] = useState([]);
  const [loadingFaqs, setLoadingFaqs] = useState(false);

  const [messages, setMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);

  const token = localStorage.getItem("token");
  const userData = token ? jwtDecode(token) : null;

  const config = configModule.config();

  const openChatbot = async () => {
    setIsChatOpen(true);

    if (faqs.length > 0) return;

    try {
      setLoadingFaqs(true);

      const response = await axios.get(
        `${config.apiBaseUrl}/get-faqsdata`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setFaqs(response.data.data || []);
    } catch (error) {
      console.error("Failed to load FAQs:", error);
    } finally {
      setLoadingFaqs(false);
    }
  };

  const selectFaq = (faq) => {
    if (isTyping) return;

    // User question - RIGHT SIDE
    setMessages((prev) => [
      ...prev,
      {
        id: Date.now(),
        type: "user",
        text: faq.question,
      },
    ]);

    // Bot typing
    setIsTyping(true);

    // Bot answer after 3 seconds
    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        {
          id: Date.now() + 1,
          type: "bot",
          text: faq.answer,
        },
      ]);

      setIsTyping(false);
    }, 3000);
  };

  const closeChatbot = () => {
    setIsChatOpen(false);
    setMessages([]);
    setIsTyping(false);
  };

  return (
    <main
      style={{
        height: "100%",
        width: "100%",
        overflow: "auto",
        display: "flex",
      }}
    >
      <NavBar />

      <Outlet />

      {/* Customer Care Button */}
      <button
        className="customer-care-button"
        onClick={openChatbot}
        title="Customer Care"
        aria-label="Open Customer Care"
      >
        <FaHeadset size={27} />
      </button>

      {/* Chatbot Popup */}
      {isChatOpen && (
        <div className="chatbot-container">

          {/* Header */}
          <div className="chatbot-header">
            <div className="chatbot-title">

              <div className="chatbot-icon">
                <FaHeadset />
              </div>

              <div>
                <h3 style={{ fontFamily: "'Inter var'", fontWeight: "800" }}>Support</h3>
                <span>We're here to help</span>
              </div>

            </div>

            <button
              className="chatbot-close"
              onClick={closeChatbot}
              aria-label="Close chatbot"
            >
              <FaTimes />
            </button>
          </div>

          {/* Body */}
          <div className="chatbot-body">

            {/* Welcome */}
            <div className="welcome-message">
              <h4>
                👋 Welcome {userData?.full_name || ""}!
              </h4>

              <p className="mb-0">
                Hello! How can we help you today?
              </p>
            </div>

            {/* Chat Messages */}
            <div className="chat-messages">

              {messages.map((msg) => (
                <div
                  key={msg.id}
                  className={`chat-message ${
                    msg.type === "user"
                      ? "user-message"
                      : "bot-message"
                  }`}
                >

                  {/* Bot Avatar */}
                  {msg.type === "bot" && (
                    <div className="message-avatar">
                      <FaHeadset />
                    </div>
                  )}

                  {/* Message */}
                  <div className="message-content">
                    {msg.text}
                  </div>

                </div>
              ))}

              {/* Typing */}
              {isTyping && (
                <div className="chat-message bot-message">

                  <div className="message-avatar">
                    <FaHeadset />
                  </div>

                  <div className="typing-indicator">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>

                </div>
              )}

            </div>

            {/* FAQ List */}
            <div className="faq-list">

              <p className="faq-heading">
                Frequently Asked Questions
              </p>

              {loadingFaqs ? (
                <p>Loading questions...</p>
              ) : faqs.length === 0 ? (
                <p>No FAQs available.</p>
              ) : (
                faqs.map((faq, index) => (
                  <button
                    key={faq.id}
                    className="faq-question"
                    onClick={() => selectFaq(faq)}
                    disabled={isTyping}
                  > {index + 1}.&nbsp;
                    {faq.question}
                  </button>
                ))
              )}

            </div>

          </div>
        </div>
      )}
    </main>
  );
};

export default MainLayout;